import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

function Services() {
  const { t } = useTranslation()

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768)
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const videoRefs = [useRef(null), useRef(null), useRef(null), useRef(null)]

  const steps = [
    {
      title: t('service.shineTitle'),
      description: t('service.shineDesc'),
      video: '/about/assets/polish1.mp4',
      icon: 'la-magic',
    },
    {
      title: t('service.fitTitle'),
      description: t('service.fitDesc'),
      video: '/about/assets/size2.mp4',
      icon: 'la-fingerprint',
    },
    {
      title: t('service.secureTitle'),
      description: t('service.secureDesc'),
      video: '/about/assets/push3.mp4',
      icon: 'la-wrench',
    },
    {
      title: t('service.settingTitle'),
      description: t('service.settingDesc'),
      video: '/about/assets/set4.mp4',
      icon: 'la-gem',
    },
  ]

  const openFullscreen = (index) => {
    const video = videoRefs[index].current
    if (!video) return

    // Temporarily use 'contain' for fullscreen to prevent zooming
    video.style.objectFit = 'contain'

    if (video.requestFullscreen) {
      video.requestFullscreen()
    } else if (video.webkitRequestFullscreen) {
      video.webkitRequestFullscreen()
    } else if (video.msRequestFullscreen) {
      video.msRequestFullscreen()
    }
  }

  return (
    <section className="tc-services-style1">
      <div className="content section-padding section-padding-x">
        <div className="container">
          <div className="title mb-80 text-center">
            <h4 className="color-666 text-uppercase wow marcellus">{t('service.title')}</h4>
          </div>
          <div className="services">
            <div className="row">
              {steps.map((step, index) => (
                <div className="col-lg-3" key={index}>
                  <div
                    className={`service-card wow fadeInUp`}
                    data-wow-delay={`${0.2 + index * 0.2}s`}
                  >
                    <div className="header-inline">
                      <h5 className="marcellus">{step.title}</h5>
                    </div>

                    <div className="video-wrapper">
                      <video
                        ref={videoRefs[index]}
                        src={step.video}
                        className="img-cover"
                        muted
                        autoPlay={!isMobile}
                        loop
                        playsInline
                        preload="metadata"
                      />
                    </div>
                    <div className="text color-666 mt-50 marcellus">{step.description}</div>
                    <span className="arrow" onClick={() => openFullscreen(index)} role="button">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="text-center">
            <a
              href="/contact"
              className="butn rounded-pill mt-80 hover-bg-black bg-brown2 text-white marcellus"
            >
              <span>
                {t('service.cta')}
                <i className="small ms-1 ti-arrow-top-right"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Services
